var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPart3GuidesIcon = function SvgPart3GuidesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "m8.146 5.03 1.181 3.01a.37.37 0 0 0 .207.214l3.189 1.328a.191.191 0 0 0 .253-.243L11.37 5.263a.7.7 0 0 0-.402-.418L9.152 4.06a.764.764 0 0 0-1.012.975l.006-.006z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M17.569 14.51a1.89 1.89 0 0 0 .021-1.463 1.86 1.86 0 0 0-1.012-1.05L6.388 7.762a.37.37 0 0 1-.222-.23l-.601-1.945a.76.76 0 0 0-.446-.462l-1.982-.847a.764.764 0 0 0-.963.326.76.76 0 0 0-.098.357l-.074 4.05a.76.76 0 0 0 .424.736l4.264 1.894a.2.2 0 0 1 .116.174.21.21 0 0 1-.117.176l-3.93 1.667a.76.76 0 0 0-.456.726c.005.19.08.37.212.507a.7.7 0 0 0 .299.189l2.178.774a.76.76 0 0 0 .486.01l6.111-1.914a.35.35 0 0 1 .275.022l3.191 1.527a1.91 1.91 0 0 0 2.52-.985l-.006-.005z"
  })));
};
export { SvgPart3GuidesIcon as ReactComponent };